import { VIDEO_VARIANTS } from '@workspace/constants';
import { AppImage, AppVideoImage } from '@/app/common';
import { GALLERY_ASPECT, sanityHeroLoader, sanityImageSrc } from '@/sanity/lib/image';
import type { SanityImage } from '@workspace/interfaces';

interface RenderMediaParams {
  isVideo: boolean;
  video?: string;
  image: SanityImage;
  resolvedHeaderText: string;
}

export const renderMedia = ({ isVideo, video, image, resolvedHeaderText }: RenderMediaParams) => {
  // Render video
  if (isVideo && video) {
    return <AppVideoImage video={video} variant={VIDEO_VARIANTS.VideoWithoutText} wrapperClassName="h-full" />;
  }

  // Render image
  return image?.url ? (
    <AppImage
      loader={sanityHeroLoader(image, GALLERY_ASPECT)}
      src={sanityImageSrc(image, { width: 544, height: 544 })}
      alt={image.alt || resolvedHeaderText}
      width={544}
      height={544}
      className="w-full h-81.75 md:w-136 md:h-136 md:mx-auto"
    />
  ) : (
    <div className="bg-placeholder! w-full h-81.75 md:w-136 md:h-136 md:mx-auto"></div>
  );
};
